import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import PageTableHeader from "../../../components/pageTableHeader/pageTableHeader";
import CommonForm from "../../../components/form/form";
import useCommonFetch from "../../../../hooks/useCommonFetch";
import {
  createVendor,
  deleteVendor,
  getCategoryList,
  updateVendor,
} from "../../../../services/workspace/inventory.service"; // make sure path is correct
import toast from "react-hot-toast";
import { convertToLabelValue } from "../../../../utils/common";
import { useLocation } from "react-router-dom";

const AddVendors = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [isError, setIsError] = useState(false);
  const [selectedValue, setSelectedValue] = useState("");
  const [isEditValue, setIsEditValue] = useState(null);
  const [catLoading, setCatLoading] = useState(false);
  const [categories, setCategories] = useState([]);
  const location = useLocation();
  const vendorData = location.state?.vendorData || null;

  const fetchCategory = () => {
    setCatLoading(true);

    getCategoryList({})
      .then((response) => {
        setCatLoading(false);

        // ✅ Corrected: API gives categories in response.category.data
        const categoriesData = response?.category?.data || [];

        const formattedCategories = categoriesData.map((cat) => ({
          label: cat.name,
          value: cat.id, // or cat.uuid if you want UUID
        }));

        setCategories(formattedCategories);
      })
      .catch((error) => {
        setCatLoading(false);
        toast.error("Failed to fetch categories!");
        console.error("Category Fetch Error:", error);
      });
  };

  useEffect(() => {
    fetchCategory();
  }, []);

  const handleSelectChange = (value) => {
    setSelectedValue(value);
  };

  const items = [
    { label: "Vendor", path: "/inventory/vendor" },
    { label: id ? "Edit Vendor" : "Add Vendor", path: "" },
  ];

  const actions_type = {
    DELETE: "DELETE",
    VIEW: "VIEW",
  };

  const {
    loading,
    data: tableData,
    total: totalData,
    currentPage,
    search,
    action,
    handleSearchChange,
    handlePageChange,
    openModal,
    closeModal,
    handleCreate,
    handleUpdate,
    handleDelete,
    fetchData,
    softDelete,
    sortingUIProps,
  } = useCommonFetch();

  // Example fields for CommonForm
  const comprehensiveFields = [
    // General Information
    {
      type: "section_header",
      name: "contact_section",
      label: "General Information",
      colSpan: 12,
      className: "border-b pb-2 mb-2 mt-6 text-xl font-semibold",
    },
    {
      name: "name",
      label: "Vendor Name",
      type: "text",
      required: true,
      colSpan: 3,
    },
    {
      name: "abrv",
      label: "Abbreviation",
      type: "text",
      colSpan: 3,
    },
    {
      name: "tags",
      label: "Tags",
      type: "text",
      required: true,
      colSpan: 3,
    },
    {
      name: "categories",
      label: "Categories",
      type: "select",
      required: true,
      options: categories || [],
      multiple: true,
      colSpan: 3,
    },

    // Contact Information
    {
      type: "section_header",
      name: "contact_section",
      label: "Contact Information",
      colSpan: 12,
      className: "border-b pb-2 mb-2 mt-6 text-xl font-semibold",
    },
    {
      name: "phone",
      label: "Phone Number",
      type: "contact",
      required: true,
      countryCodeName: "country_code",
      placeholder: "Enter phone number",
      colSpan: 3,
    },
    {
      name: "phone2",
      label: "Alternate Phone Number",
      type: "contact",
      required: true,
      countryCodeName: "country_code2",
      placeholder: "Enter alternate phone number",
      colSpan: 3,
    },
    {
      name: "email",
      label: "Email",
      type: "email",
      required: true,
      colSpan: 3,
    },

    {
      name: "website",
      label: "Website",
      type: "text",
      colSpan: 3,
    },

    // Location Information
    {
      type: "section_header",
      name: "contact_section",
      label: "Location Information",
      colSpan: 12,
      className: "border-b pb-2 mb-2 mt-6 text-xl font-semibold",
    },
    {
      name: "address",
      label: "Address",
      type: "textarea",
      required: true,
      readOnly: true,
    },
  ];

  useEffect(() => {
  if (vendorData) {
    setIsEditValue(vendorData);
  }
}, [vendorData]);

  // Handle form submission
  const handleSubmit = async (values, { setSubmitting, resetForm }) => {
    try {
      const payload = {
        ...values,
      };
      if (isEditValue) {
        // ✅ update flow
        await handleUpdate(payload, isEditValue.uuid, updateVendor, {
          successMessage: "Vendor updated successfully!",
          errorMessage: "Failed to update vendors!",
        });
      } else {
        // ✅ create flow
        await handleCreate(payload, createVendor, {
          successMessage: "Vendors created successfully!",
          errorMessage: "Failed to create vendor!",
        });
      }
    } catch (error) {
      console.error("Submit error:", error);
    } finally {
      setSubmitting(false);
      setTimeout(() => {
        navigate("/inventory/vendor");
      });
    }
  };

  const handleCancel = () => {
    setIsEditValue(null);
  };

  return (
    <div className="w-full flex flex-col gap-2">
      <PageTableHeader
        breadcrumbs={items}
        isSearch={false}
        isFilter={false}
        buttons={false}
      />

      {/* If you only want CommonForm, remove AddVendorForm */}
      <div className="p-4 bg-white rounded-md">
        <CommonForm
          fields={comprehensiveFields}
          initialData={
            vendorData
              ? { country_code: "+91", country_code2: "+91", ...vendorData }
              : { country_code: "+91", country_code2: "+91" }
          }
          onSubmit={handleSubmit}
          submitButtonText="Submit"
          onCancel={handleCancel}
          cancelButtonText="Reset"
          columnsPerRow={1}
          gap="gap-4"
          rowClassName=""
          fieldClassName="bg-white p-3 rounded shadow-sm"
        />
      </div>
    </div>
  );
};

export default AddVendors;
